import { useContext } from 'react';

import SeedOrdersContext from './SeedOrdersContext';

const useSeedOrders = () => useContext(SeedOrdersContext);

export default useSeedOrders;
